// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-4bdf1bbc]{display:inline-block;width:206px;height:32px;border:1px solid #c0c4cc;border-radius:5px}.el-row[data-v-4bdf1bbc]{font-size:16px}.btn[data-v-4bdf1bbc]{text-align:center}button[data-v-4bdf1bbc]{width:73px;height:28px;border-radius:5px;margin:0 20px}", ""]);
// Exports
module.exports = exports;
